<template>
  <div class="contact-details">
    <b-row>
      <b-col cols="12" lg="6">
        <h5 class="text-primary font-weight-bold pb-2">
          District Forester
        </h5>
        <DetailRow
          label="Name"
          :value="`${districtForesterUser.firstName} ${districtForesterUser.lastName}`"
        />
        <AddressDetails
          full
          title="Physical Address"
          :address="districtForesterUser.physicalAddress"
        />
        <AddressDetails
          full
          title="Mailing Address"
          :address="districtForesterUser.mailingAddress"
        />
        <ContactDetailLine
          label="Phone:"
          :url="`tel:${districtForesterUser.phoneNumber}`"
          :value="districtForesterUser.phoneNumber | phoneString"
        />
        <ContactDetailLine
          label="Email:"
          :url="`mailto:${districtForesterUser.email}`"
          :value="districtForesterUser.email"
        />
      </b-col>
      <b-col cols="12" class="d-lg-none">
        <hr class="border-dark">
      </b-col>
      <b-col lg="6" class="border-lg-left border-dark">
        <div class="pl-lg-3">
          <h5 class="text-primary font-weight-bold pb-2">
            Forest Protection {{region.name}} Region Office
          </h5>
          <AddressDetails full :address="region.officeAddress" />
          <ContactDetailLine
            label="Phone:"
            :url="`tel:${region.officePhone}`"
            :value="region.officePhone | phoneString"
          />
          <ContactDetailLine
            label="Email:"
            :marginBottom="false"
            :url="`mailto:${region.email}`"
            :value="region.email"
          />
        </div>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import LookupModules from '@/store/moduleConfig';
import ContactDetailLine from '@/components/common/ContactDetailLine.vue';
import AddressDetails from '@/components/account/AddressDetails.vue';
import DetailRow from '@/components/DetailRow.vue';

export default {
  name: 'MFSContactDetails',
  components: {
    AddressDetails,
    ContactDetailLine,
    DetailRow,
  },
  props: {
    townGeocodeNum: {
      type: Number,
    },
  },
  created() {
    this.$store.dispatch(`${LookupModules.TOWNS.namespace}/fetchOptions`);
  },
  computed: {
    ...mapState(LookupModules.TOWNS.namespace, {
      townOptions: state => state.options,
      townsLoading: state => state.loading,
    }),
    ...mapGetters(LookupModules.TOWNS.namespace, ['getProperty']),
    region() {
      return this.getProperty(this.townGeocodeNum, 'region');
    },
    districtForesterUser() {
      return this.getProperty(this.townGeocodeNum, 'districtForesterUser');
    },
  },
};
</script>
